module.exports = __webpack_public_path__ + "static/media/Scenario4Header.ffa81dcb.jpg";